import { Actions, EReducerActions } from './model';

export const setSuccessWithWarning = <T>(data: T, errors: string[]): Actions<T> => ({
  actionType: EReducerActions.WITH_WARNING,
  payload: { error: errors, data: data },
});

export const setRequestFailed = <T>(): Actions<T> => ({
  actionType: EReducerActions.REQUEST_FAILED,
});

export const setSuccess = <T>(data: T): Actions<T> => ({
  actionType: EReducerActions.SUCCESS,
  payload: { data: data },
});

export const setReset = <T>(): Actions<T> => ({ actionType: EReducerActions.RESET });
